import { useMemo } from 'react'
import { parseUrl, IImageProps } from '@rankmi/aws-image-handler'

import { OverridableComponent } from 'interfaces/overridable-props'
import { ImgTypeMap } from './types'

const { REACT_APP_CLOUD_FRONT_BASE_URL } = process.env

const cloudfrontBaseUrl =
  (REACT_APP_CLOUD_FRONT_BASE_URL || '').replace(/\/$/, '') + '/'

export const optimizeImage = (image?: string, config?: IImageProps) => {
  const { width, height } = { ...config }
  if (
    !image ||
    !REACT_APP_CLOUD_FRONT_BASE_URL ||
    (!width && !height) ||
    image.includes('.gif') ||
    image.includes('blob:')
  )
    return image
  else {
    const props: IImageProps = {
      width,
      height,
      resizeMode: 'cover',
    }
    try {
      const regex = /([\w|\d|-]*)\..*/g
      const url = new URL(image)
      if (!url.host.match(/s3.*.amazonaws.com/)) return image
      const [, bucket] = url.host.split(regex)
      const assetPath = url.pathname.slice(1)
      if (!bucket) return image
      const optimizedAvatar = parseUrl(
        cloudfrontBaseUrl,
        bucket,
        assetPath,
        props
      )
      return optimizedAvatar
    } catch {
      return image
    }
  }
}

export const Img: OverridableComponent<ImgTypeMap> = ({
  src: srcBase,
  alt,
  imageHandlerProps,
  component: Component = 'img',
  ...props
}) => {
  const src = useMemo(
    () => srcBase && optimizeImage(srcBase, imageHandlerProps),
    [imageHandlerProps, srcBase]
  )
  return <Component src={src} alt={alt} {...props} />
}

export * from './types'
export default Img
